import { RefObject, useEffect, useState } from "react";

// Tracks a container's live `clientWidth`, `undefined` until first measured
export function useContainerWidth(
    containerRef: RefObject<HTMLElement | null> | undefined,
    reattachKey?: unknown
) {
    const [availableWidth, setAvailableWidth] = useState<number>();

    // Measures the container and observe it for resizes
    useEffect(() => {
        const element = containerRef?.current;
        if (!element) {
            return;
        }
        const measure = () => setAvailableWidth(element.clientWidth);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [containerRef, reattachKey]);

    return availableWidth;
}
